module.exports = __webpack_public_path__ + "media/images/frontend/logo-65ab9c3c8582218bc7c6f92e65577c52.png";